import { getAPICall, getAPIProps, postAPICall, postAPIProps, defaultCallback } from './BaseAPI';

export const getProductCategoriesData = async (callback=defaultCallback) => {
  return await getAPICall({ route: 'product/getproductcategoriesdata', callback });
}

export const getProductFamiliesData = async (categoryId:string|number, callback=defaultCallback) => {
  return await getAPICall({ route: 'product/getproductfamiliesdatabydiplayname/' + categoryId, callback });
}

export const getVehicleRentalProdLocation = async (payload:any, callback=defaultCallback) => {
  return await postAPICall({ route: 'product/vehicleRentalProdLocation', payload, callback });
}

export const getProductLinesData = async (categoryId:string|number, callback=defaultCallback) => {
  return await getAPICall({ route: 'product/getproductlinesdata2/' + categoryId, callback });
}

export const getExtrasData = async (callback=defaultCallback) => {
  return await getAPICall({ route: 'settings/getextrasdata', callback });
}

export const getPriceDataByGroup = async (payload:any, callback=defaultCallback) => {
  return await postAPICall({ route: 'price/getpricedatabygroup', payload, callback });
}

export const getPriceDataByMultipleGroups = async (payload:any, callback=defaultCallback) => {
  return await postAPICall({ route: 'price/getpricedatabymultiplegroups', payload, callback });
}

export const getPriceLogicData = async (callback=defaultCallback) => {
  return await getAPICall({route: 'price/getpricelogicdata', callback});
}

export const getHeaderData = async (tableId:string|number, callback=defaultCallback) => {
  return await getAPICall({route:'price/getheaderdata/' + tableId, callback});
}

export const getTableData = async (tableId:string|number, callback=defaultCallback) => {
  return await getAPICall({route:'price/gettabledata/' + tableId, callback});
}

export const createReservation = async (payload:any, callback=defaultCallback) => {
  return await postAPICall({ route : 'reservations/createreservation', payload, callback});
};

export const createReservationPre = async (payload:any, callback=defaultCallback) => {
  return await postAPICall({ route : 'reservations/createreservationpre', payload, callback});
};

export const updateReservationPre = async (payload:any, callback=defaultCallback) => {
  return await postAPICall({ route : 'reservations/updatereservationpre', payload, callback});
};

export const removeReservation = async (payload:any, callback=defaultCallback) => {
  return await postAPICall({ route : 'reservations/removereservation', payload, callback});
};

export const createTransaction = async (payload:any, callback=defaultCallback) => {
  return await postAPICall({ route : 'reservations/createtransaction', payload, callback});
};

export const getExtrasDataByDisplayName = async (payload:any,callback=defaultCallback) => {
  return await postAPICall({ route: 'settings/getextrasdatabydisplayname', payload, callback });
}

export const verifyQuantityByDisplayName = async (payload:any,callback=defaultCallback) => {
  return await postAPICall({ route: 'reservations/verifyquantitybydisplayname', payload, callback });
}

export const getDiscountCodes = async (callback=defaultCallback) => {
  return await getAPICall({ route: 'settings/getdiscountcodesdata', callback });
}

export const getAvaliableSheet = async (payload:any,callback=defaultCallback) => {
  return await postAPICall({ route: 'reservations/getavailablesheetecommerce/', payload, callback });
}

export const getBusyPeriods = async (payload: any, callback = defaultCallback) => {
  return await postAPICall({ route: 'reservations/getbusyperiods/', payload, callback });
}

export const getBackupData = async (payload:any,callback=defaultCallback) => {
  return await postAPICall({ route: 'reservations/getbackupdata/', payload, callback });
}

export const getValidStartDate = async (payload:any,callback=defaultCallback) => {
  return await postAPICall({ route: 'settings/getvalidstartdate/', payload, callback });
}

export const attachDocument = async (payload:any,callback=defaultCallback) => {
  return await postAPICall({ route: 'reservations/attachdocument/', payload, callback });
}

export const attachDocuments = async (payload:any,callback=defaultCallback) => {
  return await postAPICall({ route: 'reservations/attachdocuments/', payload, callback });
}

export const getStoreContentData = async (brandId:string|number, callback=defaultCallback) => {
  return await getAPICall({ route: 'settings/getcontentbybrandid/' + brandId, callback });
}

export const getBrandsLocationsData = async (callback=defaultCallback) => {
  return await getAPICall({ route: 'price/getbrandslocationsdata', callback });
}

export const getStoreLocationsData = async (params?: Record<string, string | number | boolean>, callback=defaultCallback) => {
  return await getAPICall({ route: 'settings/getlocationsdata', params, callback });
};

export const activateBodhiProtect = async (payload:any, callback=defaultCallback) => {
  return await postAPICall({ route : 'reservations/activatebodhiprotect', payload, callback});
};

export const expirePublicLink = async (payload:any, callback=defaultCallback) => {
  return await postAPICall({ route : 'reservations/expirepubliclink', payload, callback});
};

export const getProductDetailByQRHash = async (payload:any, callback=defaultCallback) => {
  return await postAPICall({ route : 'product/getproductdetailbyqrhash', payload, callback});
};

export const getDriverScreeningConfig = async  (params?: Record<string, string | number | boolean>, callback=defaultCallback) => {
  return await getAPICall({route:'settings/getstorequiz', params, callback});
};

export const getDeliveryCharge = async (payload:any, callback=defaultCallback) => {
  return await postAPICall({ route: 'price/getdeliverycharge', payload, callback });
}

export const getPricesByProductFamily = async (payload:any, callback=defaultCallback) => {
  return await postAPICall({ route: 'price/getpricesbyproductfamily', payload, callback });
}

export const checkProductTimeSlotAvailability = async (payload:any, callback=defaultCallback) => {
  return await postAPICall({ route: 'product/checktimeslotavailability', payload, callback });
}

export const checkQRQuickOrderAvailability = async (payload:any, callback=defaultCallback) => {
  return await postAPICall({ route: 'product/qr-quick-order/check-availability', payload, callback });
}

export const sendDriverDocumentsRequests = async (payload:any, callback=defaultCallback) => {
  return await postAPICall({ route: 'reservations/autocheckandsenddocumentrequests', payload, callback });
}